module.exports = __webpack_public_path__ + "img/interactive-fountain_11.15ccb40d.jpg";